module.exports = __webpack_public_path__ + "img/dog-engine-white.2293753f.svg";